/**
 * Reduces a string to a key for loose comparison: lowercase letters and digits
 * only, so values that differ only in case, spacing, or punctuation match.
 *
 * @example
 * ```ts
 * toLooseKey('Bud_ref') // 'budref'
 * toLooseKey(' PACCT Pivot ') // 'pacctpivot'
 * ```
 */
export function toLooseKey(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '')
}

/**
 * Whether two strings are equal after {@link toLooseKey}.
 */
export function isLooselyEqual(a: string, b: string): boolean {
  return toLooseKey(a) === toLooseKey(b)
}

/**
 * Trims a string and collapses every run of whitespace (including newlines and
 * tabs) into a single space.
 */
export function normalizeWhitespace(value: string): string {
  return value.replace(/\s+/g, ' ').trim()
}
